import tw, { styled } from 'twin.macro';
import SVGIcon from '../SVGIcon/SVGIcon';
import { Meta } from '../../styled components/Typography';

export const StyledFeedbackMessage = styled.div(() => [tw`mt-4 flex items-start`]);

export const StyledFeedbackMessageText = styled(Meta).attrs(() => ({
  as: 'p'
}))(({ $variant }) => [
  $variant === 'error' && tw`text-red-base`,
  $variant === 'info' && tw`text-blue-base`
]);

export const StyledFeedbackMessageIcon = styled(SVGIcon).attrs(({ $iconSize }) => ({
  size: $iconSize
}))(({ $variant }) => [
  tw`mr-4 inline-block`,
  $variant === 'error' && tw` fill-red-base`,
  $variant === 'info' && tw` fill-blue-base`
]);
